<template>
  <div :data-testid="props.dataTestid" :class="$attrs.class || 'relative overflow-x-auto shadow-md sm:rounded-lg'" v-bind="$attrs">
    <slot name="header"></slot>
    <table :data-testid="props.dataTestid+'-table'" class="w-full text-sm text-left rtl:text-right text-gray-500  " :id="randomId">
      <thead class="text-xs text-gray-700 uppercase ">
      <tr :data-testid="props.dataTestid+'-tr'">
        <th scope="col" class="p-3" v-if="props.checkable">
          <div class="flex items-center">
            <TsCheckbox v-model="model" @change="emit('check')" />
          </div>
        </th>
        <template v-for="{text, value, sortable} in props.headers" :key="value">
          <th scope="col" class="md:px-1 max-md:first:text-left max-md:last:text-right text-info">
            <span >
              <span class="text-[16px] max-md:px-2" >{{ text }}</span>
               <TsIcon :data-testid="props.dataTestid+'-icon'" class="cursor-pointer" v-if="sortable" name="radix-icons:caret-sort" size="18" @click="emit('sort', value)" />
            </span>
          </th>
        </template>
      </tr>
      </thead>
      <tbody>
      <template v-for="item in props.bodyItems">
        <tr :data-testid="props.dataTestid+'-tr'"  :class="[{'border border-natural-light-grey' : props.bordered}]">
          <slot :item="item" />
        </tr>
      </template>
      </tbody>
    </table>
    <slot name="pagination"></slot>
  </div>
</template>

<script setup lang="ts">
import {ref,onMounted} from 'vue';
import {useRandomUUID} from "~/composables/useRandomUUID";
const randomId: Ref<string> = ref("");

const model = defineModel()

// Generating random ID::
onMounted(() => {
  randomId.value = useRandomUUID();
});

// Dynamic attribute binding
defineOptions({
  inheritAttrs: false,
});

const TsCheckbox = defineAsyncComponent(
    () => import('~/components/atoms/TsCheckbox.vue')
);  

const emit = defineEmits(['sort', 'check'])
type Props = {
  headers?: {text: string, value: string, sortable?: boolean}[];
  bodyItems?: string[];
  bordered?: boolean;
  checkable?: boolean;
  dataTestid:string;
}

const props = withDefaults(defineProps<Props>(), {
  headers: () => [],
  bodyItems: () => [],
  bordered: false,
  checkable: false,
});
</script>
